module.exports = __webpack_public_path__ + "img/people.2e59fb2.svg";